import { render } from "./--ServiceDatatable.vue?vue&type=template&id=53efc399"
import script from "./--ServiceDatatable.vue?vue&type=script&lang=js"
export * from "./--ServiceDatatable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__